export const MAX_FILE_SIZE = 100000000;
